/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import {objectToArray} from './Helpers'
const HOME = '/dashboard'
const FLEETS = '/fleets'
const FAULTS = '/faults'
const LOGIN = '/'
const LOGOUT = '/logout'
const USER = '/users?current=true'
const SETTINGS = '/settings'
const SECURED = '/app'
const TOKEN = '/tokens'
const FAULT_NEW = '/faults/new'
const USERS = "/administration/users"
const DASHBOARD = "/dashboard"
const LEARNING_LOOP_ADMIN = "/administration/learningLoop"
const APP_CONFIG_ADMIN = "/administration/appConfig"

const PROJECTS = "/project"
const FLEETS_ADMIN = "/administration/fleets"
const ASSETS_ADMIN = "/administration/assets"

const ASSETS = "/assets"

const NOTIFICATIONS = '/notifications'
const ENGINE_HISTORY = '/engineHistory'

export const Routes = {
    HOME,
    FLEETS,
    FAULT_NEW,
    FAULTS,
    LOGIN,
    LOGOUT,
    USER,
    SETTINGS,
    SECURED,
    PROJECTS,
    TOKEN,
    USERS,
    DASHBOARD,
    FLEETS_ADMIN,
    ASSETS_ADMIN,
    LEARNING_LOOP_ADMIN,
    APP_CONFIG_ADMIN,
    ASSETS,
    NOTIFICATIONS,
    ENGINE_HISTORY,
}

export const FIRST_LEVEL_ROUTES = objectToArray(Routes)
    .filter(route => {
        const routeSegments = route.split('/')
        return !!(routeSegments.length === 2 && !routeSegments[0] && routeSegments[1])
    })
